import Vue from 'vue';
import accountService from './index';

const success = (response, context) => {
  toastr.success(context.$t('account.settings.user_platforms_section.airbnb_account_deleted'));
  accountService.getAirbnbAccounts(context);
};

const failed = (error) => {
  toastr.error(error);
};

export default (context, id) => Vue.$http.post(`/delete-airbnb-account/${id}`).then((response) => {
  if (response && response.status === 200) {
    success(response, context);
  }
})
  .catch((error) => {
    failed(error);
  });



// WEBPACK FOOTER //
// ./src/app/services/account/deleteAirbnbAccount.js